module.exports = __webpack_public_path__ + "img/search-hero-overflow-honda.271546cd.png";